/* eslint-disable max-nested-callbacks */
/* eslint-disable no-nested-ternary */
import { EEventType } from './../../enums/EEventType';
import { ERemoteType, ISearchSuffix, IRemoteDataObj, IRemoteData, IRemoteGuessData, IOYSearchProps, ISearchState, IOYSearchDatalist } from "./const";
import template from "./index.art";
import tDatalist from './templates/datalist.art';
import tAutoComplete from './templates/autoComplete.art';
import tAutoGuessComplete from './templates/autoGuessComplete.art';
import styles from "./index.module.less";
import { ESearchEventName } from "./enum";
import OY from "../../types/OY";
import { jeact } from "../../decorators/jeact";
import escapeRegExp from '../../utils/escapeRegExp';

@jeact()
export default class OYSearch extends OY<IOYSearchProps, ISearchState> {
  static displayName = 'OYSearch';

  static defaultProps: Partial<IOYSearchProps> = {
    growingTrack: true,
    width: 450,
    maxlength: 50,
    maxDataListLength: 6,
    hotSearch: [],
    dataSource: []
  }

  state: ISearchState = {
    current: 0,
    inputWidth: 0,
    inputValue: [],
    defaultPlaceholder:''
  }

  $node = {
    input: $(),
    searchHot: $(),
    inputDatalist: $(),
    inputAutoComplete: $(),
    inputAutoGuessComplete: $()
  }
  private isDefaultSearch = false;  //是否为默认搜索

  private autoCompleteTimeout: any = 0;

  private currentRemoteData: IRemoteData[] = []; // 当前下拉联想的数据
  private currentRemoteGuessData: IRemoteGuessData[] = [];  // 当前下拉猜你想找的数据

  setValue(value: string) {
    // console.log(value, this.props, 'this.props')
    this.setState({ inputValue: this.state.inputValue.map(_va => value) })
  }

  /**
   * 获取当前输入框的值
   * @exports
   */
  getCurrentInputValue() {
    // console.log(this.state.current, this.state.inputValue[this.state.current], this.props, 'getCurrentInputValue')
    return this.state.inputValue[this.state.current]
  }

  /**
   * 获取默认搜索词
   */
  getDefaultSearch() {
    const that = this;
    $.ajax({
      url: '/search-ng/searchWord/queryOneRandom',
      success(res) {
        let placeholder = that.props.dataSource[0].placeholder;
        let isDefaultSearch = false;
        if (res) {
          isDefaultSearch = true;
          placeholder = res;
        }
        that.isDefaultSearch = isDefaultSearch;
        that.setState({
          defaultPlaceholder: placeholder
        })

      }
    });
  }
  /**
   * 设置当前输入框的值
   * @param value
   * @exports
   */
  setCurrentValue(value: string) {
    // console.log(this.state.current, this.state.inputValue[this.state.current], this.props, 'setCurrentValue')
    this.setState({ inputValue: this.state.inputValue.map((_va, index) => index === this.state.current ? value : _va) });
  }

  /**
   * 获取当前的datalist
   * @exports
   */
  getCurrentDataList() {
    // console.log(this.state.current, this.props, 'getCurrentDataList')
    return JSON.parse(JSON.stringify(this.props.dataSource[this.state.current].datalist || []))
  }

  /**
   * 更新datalist数据
   *
   * @description 当你需要更新datalist又不能触发搜索全局刷新时.请使用这个方法.
   * @param value
   * @exports
   */
  updateCurrentDataList(list: IOYSearchDatalist[]) {
    // console.log(this.state.current, this.props, 'updateCurrentDataList')
    this.props.dataSource[this.state.current].datalist = list;
    this._renderDatalist(false);
  }

  getDerivedStateFromProps(props: IOYSearchProps, state: ISearchState) {
    // console.log(this.state.current, this.props, 'getDerivedStateFromProps')
    state.inputValue = props.dataSource.map(ds => ds.defaultValue || '');
    return { ...state };
  }
  componentDidMount() {
    const data = this.props.dataSource[0] || {};
    // console.log('this.props.dataSource',this.props.dataSource)
    if (data.placeholder === '牌号 / 品种 / 规格 / 产地 / 仓库 / 店铺名称') {
        this.getDefaultSearch();
    } else {
      this.setState({
        defaultPlaceholder: data.placeholder
      })
    }
 }
  componentWillRender() {
    const { props, state } = this
    // console.log(props, state, 'componentWillRender')
    let inputWidth = 0;
    if (props.inputWidth) {
      inputWidth = props.inputWidth;
    } else {
      inputWidth = props.width! - (props.dataSource[state.current].suffix?.length || 0) * 88;
    }

    state.inputWidth = inputWidth;
  }

  render() {
    // console.log(this.props, this.state, 'render')
    return template({ props: this.props, state: this.state, styles })
  }

  // componentDidMount() {
  //   const cValue = this.getCurrentInputValue();
  //   if (cValue) {
  //     this._renderAtuoComplete(cValue, false)
  //   }
  // }

  // componentDidUpdate() {
  //   this.autoCompleteRender(this.currentRemoteData || [], this.getCurrentInputValue(), false)
  // }

  setNode() {
    // console.log('setNode')
    this.$node = {
      input: this.$class('oy_search_input'),
      searchHot: this.$class(styles.oy_search_hot),
      inputDatalist: this.$class(styles.oy_search_input_datalist),
      inputAutoComplete: this.$class(styles.oy_search_input_autoComplete),
      inputAutoGuessComplete: this.$class(styles.oy_search_input_guessComplete)
    }
  }

  protected _renderDatalist(show = true) {
    const { dataSource, maxDataListLength } = this.props;
    // console.log(this.props, '_renderDatalist')
    const { datalist } = dataSource[this.state.current];
    if (datalist && datalist.length) {
      const tpl = tDatalist({ props: { datalist, maxDataListLength }, styles });
      this.$node.inputDatalist.html(tpl);
      if (show) {
        this.$node.inputDatalist.show();
      }
      this._bindDeleteIconClick();
    }
  }

  protected _renderAtuoComplete(key: string) {
    const { dataSource } = this.props;
    const { atuoComplete = {} } = dataSource[this.state.current];
    const { delay = 200, remote } = atuoComplete;
    if (!remote) {
      return;
    }

    if (this.autoCompleteTimeout) {
      clearTimeout(this.autoCompleteTimeout);
    }

    this.autoCompleteTimeout = setTimeout(() => {
      const value: string = this.$node.input.val() || '';
      this.getCurrentRemoteData(key).then(data => {
        if (value.trim() === key) {
          // data 对象
          this.autoCompleteRender(data, key)
        }
      })
    }, delay)
  }

  protected autoCompleteRender(data: IRemoteDataObj, value = '') {
    // console.log(data, value, 'autoCompleteRender')

    // 自动补全 数据
    this.currentRemoteData = data.associationList || [];

    this.currentRemoteGuessData = data.guessFindData || [];

    // 猜你想找 数据
    if (data.guessFindData && data.guessFindData.length) {
      const gtpl = tAutoGuessComplete({ styles, props: { data: data.guessFindData } });
      this.$node.inputAutoGuessComplete.html(gtpl);
      if (this.currentRemoteGuessData.length) {
        this.$node.inputAutoGuessComplete.show();
      } else {
        this.$node.inputAutoGuessComplete.hide()
      }
    }


    // 对匹配数据进行高亮处理
    const ekey = escapeRegExp(value);
    const reg = new RegExp(ekey, 'ig');

    const propData = data.associationList.map(da => {
      const tpl = da.name.replace(reg, match => `<span style="color:#cc0000;">${match}</span>`);
      return { ...da, tpl }
    })

    const tpl = tAutoComplete({ styles, props: { data: propData } });
    this.$node.inputAutoComplete.html(tpl);
    if (this.currentRemoteData.length) {
      this.$node.inputAutoComplete.show();
    } else {
      this.$node.inputAutoComplete.hide()
    }

    if ( this.currentRemoteData.length && this.currentRemoteGuessData.length ) {
      this.$node.inputAutoComplete.css({"top": '76px', "border-top": "none"});
      this.$node.inputAutoGuessComplete.css({"border-bottom": 'none'});
    }
    if ( this.currentRemoteData.length && !this.currentRemoteGuessData.length) {
      // console.log(this.currentRemoteData.length && !this.currentRemoteGuessData.length, 'this.currentRemoteData.length && !this.currentRemoteGuessData.length')
      this.$node.inputAutoComplete.css({"top": '38px', "border": "2px solid #cc0000"});
    }
    if ( !this.currentRemoteData.length && this.currentRemoteGuessData.length) {
      this.$node.inputAutoGuessComplete.css({"border-bottom": "2px solid #cc0000"});
    }
  }

  protected getCurrentRemoteData(value = '') {
    const { dataSource } = this.props;
    const { atuoComplete } = dataSource[this.state.current];
    return new Promise<IRemoteDataObj>((resolve) => {
      if (!atuoComplete) {
        return resolve({
          associationList: [],
          guessFindData: []
        });
      }
      const { remote } = atuoComplete;
      remote ? remote(encodeURIComponent(value.trim()), (res) => {
        // console.log(res, 'getCurrentRemoteData')
        resolve(res)
      }) :
        resolve({
          associationList: [],
          guessFindData: []
        })
    })
  }

  protected bindTabClick() {
    // console.log(222222, 'bindTabClick')
    this.$el.find(`.${styles.oy_search_tab_item}`).click((event: Event) => {
      // console.log(event, 'bindTabClick')
      const { dataSource } = this.props;
      const type = $(event.target!).attr('_type');
      const index = dataSource.findIndex(val => val.id === type);
      const tab = dataSource[index];

      if (this.state.current !== index) {
        this.setState({ current: index })
        this.eventEmitter.emit(ESearchEventName.onTabChange, tab, index)
      }
    })
  }

  bindImgClick() {
    // console.log(33333, 'bindImgClick')
    this.$class(styles.search_img).click((event: Event) => {
      const { hotSearch } = this.props;
      hotSearch?.forEach((item: any) => {
        if (item.imgUrl) {
          window.open(item.link);
        }
      })
    })
  }

  protected bindSuffixClick() {
    // console.log(44444, 'bindSuffixClick')
    this.$el.find(`.${styles.oy_search_btn}`).click((event: Event) => {
      const { dataSource } = this.props;
      const id = `${$(event.target!).attr('id')}`;
      const suffix = dataSource.reduce((pre, cur) => pre.concat(cur.suffix || []), [] as ISearchSuffix[]).find(va => `${va.id}` === id);
      this.eventEmitter.emit(ESearchEventName.onSuffixClick, suffix);
      this._handleSearch(id);
    })
  }

  /** 热词点击 */
  protected bindHotSearchClick() {
    // console.log(55555, 'bindHotSearchClick')
    this.$node.searchHot.delegate(`.${styles.oy_search_hot_item}`, 'click', (event: Event) => {
      const value = $(event.target!).data('value');
      this.eventEmitter.emit(ESearchEventName.onHotSearchClick, value)
    })
  }

  protected bindInput() {
    // console.log(66666, 'bindInput')
    this.$node.input
      .on('input', (event) => {
        let value = (event.target as HTMLInputElement).value || '';
        value = value.trim();
        // .replace(/ /g, "%20");
        const { current } = this.state;
        this.state.inputValue[current] = value;
        // console.log(66666, current, value, 'bindInput')
        this.hideDropdownList();
        if (!value) {
          // 没值渲染最近搜索
          this._renderDatalist();
        } else {
          // 有值渲染 下拉框自动补全/猜你想找
          this._renderAtuoComplete(value);
        }
      })
      .on('focus', (event) => {
        // 绑定回车监听
        $(document).off('keydown').on('keydown', this.handleDocumentKey.bind(this));

        const { value } = (event.target as HTMLInputElement);
        const trimValue = value.trim();
        // 没值渲染最近搜索
        if (!trimValue) {
          this._renderDatalist();
        } else {
          // 下拉自动补全
          this.getCurrentRemoteData(trimValue).then(data => {
            data && ((data.associationList && data.associationList.length) || (data.guessFindData && data.guessFindData.length)) ? this.autoCompleteRender(data, trimValue) : this._renderDatalist();
          })
        }
        this.eventEmitter.emit(EEventType.onFocus, event)
      })
      .on('blur', (event) => {
        $(document).off('keydown');
        this.eventEmitter.emit(EEventType.onBlur, event)
        setTimeout(() => {
          this.hideDropdownList();
        }, 200);
      })
  }

  /** 点击dataList */
  protected bindDatalistClick() {
    // console.log(7777, 'bindDatalistClick')
    this.$node.inputDatalist.delegate(`.${styles.oy_search_input_datalist_option}`, 'click', (event: Event) => {
      // const value = $(event.currentTarget!).data('value');
      const index = $(event.currentTarget!).data('index');

      const { dataSource, maxDataListLength } = this.props;
      const { datalist } = dataSource[this.state.current];

      const data = datalist![0].options[index];
      const { name, type, url } = data;

      this.handleBeforeDataListClick(data).then(res => {
        if (res) {
          if (type === ERemoteType.Shop && url) {
            window.location.href = url
          } else if (type !== ERemoteType.Shop) {
            this._handleDropdownClick(data, ESearchEventName.onAutoCompleteClick);
          }
        }
      })

      // this._handleDropdownClick(data.name, ESearchEventName.onDatalistClick);
    })
  }

  /** 点击自动补全项 */
  protected bindAutoCompleteClick() {
    // console.log(88888, 'bindAutoCompleteClick')
    this.$node.inputAutoComplete.delegate(`.${styles.oy_search_input_autocomplete_item}`, 'click', (event: Event) => {
      const index = $(event.currentTarget!).data('index');
      const data = this.currentRemoteData[index];
      const { name, type, url } = data;

      this.handleBeforeAutoCompleteClick(data).then(res => {
        if (res) {
          // 只要返回的数据中有url，就直接按照返回的url进行跳转
          if (url) {
            window.location.href = url
          } else if (type !== ERemoteType.Shop) {
            this._handleDropdownClick(data, ESearchEventName.onAutoCompleteClick);
          }
        }
      })
    })
  }

  protected _bindDeleteIconClick() {
    // console.log(99999, '_bindDeleteIconClick')
    this.$node.inputDatalist.find(`.${styles.datalistOptionIcon}`)
      .off('mousedown').on('mousedown', (ev: Event) => {
        ev.preventDefault();
        ev.stopPropagation()
      })
      .off('click').on('click', (event: Event) => {
        event.stopPropagation();
        event.preventDefault();
        const $this = $(event.target!);
        // console.log(99999, $this, '_bindDeleteIconClick')
        const parentIndex = $this.data('parent-index');
        // console.log(99999, parentIndex, '_bindDeleteIconClick')
        const index = $this.data('index');
        // console.log(99999, index, '_bindDeleteIconClick')
        let value = ''

        const { dataSource } = this.props;
        const { datalist } = dataSource[this.state.current];

        const list = datalist?.map((dl, dindex) => {
          if (dindex === parentIndex) {
            const deleteItem = dl.options.splice(index, 1);
            value = deleteItem[0].name;
            // options = dl.options.filter((option, oIdex) => oIdex !== index)
          }
          return dl;
        });

        $this.parents(`.${styles.oy_search_input_datalist_option}`).remove();
        this.$emit(ESearchEventName.onDataListRemove, value, list)
      })
  }

  private handleDocumentKey(event: any) {
    // console.log(1000000, event, 'handleDocumentKey')
    const { keyCode, key } = event as KeyboardEvent;
    // console.log(key, keyCode)
    if (event.key !== undefined) {
      if (key === 'Enter') {
        this.$node.input.trigger('blur')
        setTimeout(() => {
          this._handleEnter();
        });
        return false;
      } else if (key === 'ArrowUp') {
        this._handleArrowUp();
        return false;
      } else if (key === 'ArrowDown') {
        this._handleArrowDown();
        return false;
      }
    } else if (event.keyCode !== undefined) {
      if (keyCode === 13) {
        this.$node.input.trigger('blur')
        setTimeout(() => {
          this._handleEnter();
        });
        return false;
      } else if (keyCode === 38) {
        this._handleArrowUp();
        return false;
      } else if (keyCode === 40) {
        this._handleArrowDown()
        return false;
      }
    }
  }

  private _handleArrowUp() {
    // console.log(122222, '_handleArrowUp')
    // 如果当前列表在显示中
    const $auto = this.$node.inputAutoComplete.filter(':visible');
    if ($auto.length) {
      const $children = $auto.children();
      if (!$children.length) {
        return
      }
      const $actived = $auto.find(`.${styles.actived}`);
      let activedIndex = ($actived.length ? $actived.data('index') : 0) - 1;
      activedIndex = activedIndex < 0 ? $children.length + activedIndex : activedIndex;

      $($children.removeClass(styles.actived).get(activedIndex)).addClass(styles.actived)
    }
  }

  private _handleArrowDown() {
    // console.log(133333, '_handleArrowDown')
    // 如果当前列表在显示中
    const $auto = this.$node.inputAutoComplete.filter(':visible');
    if ($auto.length) {
      const $children = $auto.children();
      if (!$children.length) {
        return
      }
      const $actived = $auto.find(`.${styles.actived}`);
      const activedIndex = $actived.length ? $actived.data('index') : -1;
      const nextIndex = (activedIndex + 1) % ($children.length);
      $($children.removeClass(styles.actived).get(nextIndex)).addClass(styles.actived)
    }
  }

  private _handleDropdownClick(data: IRemoteData, eventname: ESearchEventName) {
    // console.log(144444, '_handleDropdownClick')
    const { name } = data;
    this.setCurrentValue(name);
    this.$node.input.val(name);
    this.eventEmitter.emit(eventname, {
      value: name,
      data,
      dataSourceId: this.props.dataSource[this.state.current]
    })
  }

  private _handleEnter() {
    // console.log(155555, '_handleEnter')
    const $auto = this.$node.inputAutoComplete.filter(':visible');
    if ($auto.length) {
      const $children = $auto.children();
      if ($children.length) {
        const $actived = $auto.find(`.${styles.actived}`);
        if ($actived.length) {
          return $actived.trigger('click')
        }
      }
    }
    this._handleSearch()
  }

  private _handleSearch(sid = '') {
    // console.log(1666666, '_handleSearch');
    //默认搜索词
    if (!this.getCurrentInputValue() && this.isDefaultSearch) {
      const defaultSearch = this.$node.input.attr('placeholder');
      // this.$node.input.val(defaultSearch);
      this.setValue(defaultSearch);
      // console.log("默认搜索词进来了",defaultSearch)
    }
    this.$node.inputDatalist.hide();
    this.$node.input.blur();

    const { id: dataSourceId, suffix = [] } = this.props.dataSource[this.state.current];

    const suffixId = sid
      ? sid
      : suffix.length
        ? suffix[0].id
        : (typeof window.GLOBAL_SEARCH_TYPE === "undefined" ? 0 : window.GLOBAL_SEARCH_TYPE);
    setTimeout(() => {
      this.eventEmitter.emit(EEventType.onSearch, {
        dataSourceId,
        suffixId,
        value: this.getCurrentInputValue()
      })
    }, 0);


  }

  private hideDropdownList() {
    // console.log(177777, 'hideDropdownList')
    this.$node.inputAutoComplete.hide();
    this.$node.inputDatalist.hide();
    this.$node.inputAutoGuessComplete.hide()
  }

  private handleBeforeDataListClick(data: IRemoteData) {
    // console.log(188888, 'handleBeforeDataListClick')
    if (!this.props.beforeDatalistClick) {
      return Promise.resolve(true);
    }
    return Promise.resolve(this.props.beforeDatalistClick(data)).then(res => {
      return typeof res === 'boolean' ? res : true
    })
  }

  /** 处理联想词点击之前事件 */
  private handleBeforeAutoCompleteClick(data: IRemoteData) {
    // console.log(199999, 'handleBeforeAutoCompleteClick')
    if (!this.props.beforeAutoCompleteClick) {
      return Promise.resolve(true);
    }
    return Promise.resolve(this.props.beforeAutoCompleteClick(data)).then(res => {
      return typeof res === 'boolean' ? res : true
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/OYSearch/index.ts